<template>
  <div class="backview">
    <div class="course-class-topback">
      <img
        class="course-left-backimg"
        src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png"
      />
      <div class="course-title">
        <div class="cn">战队管理</div>
        <div class="en">Team Management</div>
      </div>
    </div>
    <div class="content">
      <el-empty v-if="!list.length" description="暂无战队"></el-empty>
      <div class="team-card" v-for="(item, i) in list" :key="i">
        <div class="inner">
          <el-row>
            <el-col :span="8" class="t1">{{ item.teamName || '--' }}</el-col>
            <el-col :span="8" class="t2"><span class="s">项目名称</span>{{ item.name }}</el-col>
            <el-col :span="8" class="t2" align="right"><span class="s">项目方向</span>{{ item.theme }}</el-col>
          </el-row>
          <div class="con1">
            <div class="lf">
              <div class="lf-line">
                <div class="t2">
                  <span class="s">队伍组别</span>
                  {{ levelFormat(item) }}
                </div>
                <div class="t2">
                  <span class="s">队伍人数</span>
                  <template v-if="item.students">
                    {{ item.students.length }}人
                  </template>
                  <template v-else>0</template>
                </div>
              </div>
              <div class="lf-line">
                <div class="t2">
                  <span class="s">审核状态</span>
                  <el-tag :type="item.status === 0 ? 'warning' : item.status === 1 ? 'success' : item.status === 2 ? 'danger' : ''" size="small">
                    {{item.status === 0 ? '待审核' : item.status === 1 ? '审核通过' : item.status === 2 ? '审核不通过' : '' }}
                  </el-tag>
                </div>
                <div class="t2">
                  <span class="s">支付状态</span>
                  <el-tag :type="item.paydStatus ? 'success' : 'danger'" size="small">{{ item.paydStatus ? '支付完成' : '待支付' }}</el-tag>
                </div>
              </div>
              <div class="lf-line" v-if="item.status === 2">
                <div class="t2">
                  <span class="s">审核备注</span>
                  <span>{{ item.rejected }}</span>
                </div>
              </div>
            </div>
            <div class="rt">
              <div class="step-wrapper">
                <div class="step-item" v-for="(step, index) in steps" :key="index">
                  <div class="step-circle" :class="getStepClass(index, item)">
                    <i class="el-icon-check" v-if="index < item.currentStep"></i>
                    <span v-else>{{ index + 1 }}</span>
                  </div>
                  <div class="step-text" :class="getStepClass(index, item)">
                    <div class="cn">{{ step.cn }}</div>
                    <div class="en">{{ step.en }}</div>
                  </div>
                  <div class="step-line" v-if="index < steps.length - 1" :class="{ 'line-done': index < item.currentStep }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ope">
          <div class="ope-btn" v-if="item.status === 1 && !item.paydStatus && item.students" @click="handleToReg(item, 4)">去缴费</div>
          <div class="ope-btn" v-if="item.status === 2 && !item.paydStatus" @click="handleToReg(item, 1)">修改信息</div>
          <div class="ope-btn" v-if="item.status !== 0 && item.status !== 2 && !item.paydStatus" @click="handleToReg(item, 3)">{{ item.students ? '编辑战队' : '组建战队'}}</div>
          <div class="ope-btn" @click="handleToReg(item, -1)">查看详情</div>
        </div>
      </div>
      <el-table :data="list" border style="width: 100%;" v-if="false">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand-wrap">
              <!-- 指导老师列表 -->
              <div class="expand-section" style="margin-top: 20px">
                <div class="expand-title">指导老师</div>
                <el-table
                  v-if="props.row.teachers && props.row.teachers.length"
                  :data="props.row.teachers"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index" width="60"></el-table-column>
                  <el-table-column label="姓名" prop="userName"></el-table-column>
                  <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                  <el-table-column label="职位" prop="position"></el-table-column>
                  <el-table-column label="手机号" prop="phone"></el-table-column>
                  <el-table-column label="邮箱" prop="email"></el-table-column>
                </el-table>
                <div v-else class="empty-tip">暂无指导老师信息</div>
              </div>
              <!-- 学生列表 -->
              <div class="expand-section">
                <div class="expand-title">学生列表</div>
                <el-table
                  v-if="props.row.students && props.row.students.length"
                  :data="props.row.students"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index" width="60"></el-table-column>
                  <el-table-column label="姓名" prop="userName"></el-table-column>
                  <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                  <el-table-column label="年级" prop="grade"></el-table-column>
                  <el-table-column label="手机号" prop="phone"></el-table-column>
                  <el-table-column label="邮箱" prop="email"></el-table-column>
                  <el-table-column label="支付状态" prop="payStatus">
                    <el-tag type="danger" size="mini" effect="dark">未支付</el-tag>
                  </el-table-column>
                </el-table>
                <div v-else class="empty-tip">暂无学生信息</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="theme" label="参赛主题"></el-table-column>
        <el-table-column prop="name" label="项目名称"></el-table-column>
        <el-table-column prop="introduction" label="项目简介"></el-table-column>
        <el-table-column prop="teamName" label="战队名称"></el-table-column>
        <el-table-column prop="introduction" label="学校"></el-table-column>
        <el-table-column prop="schoolLevel" label="组别" :formatter="levelFormat"></el-table-column>
        <!-- 0-待审核，1-通过，2-驳回 -->
        <el-table-column prop="status" label="审核状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'warning' : scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : ''" size="small">{{ scope.row.status === 0 ? '待审核' : scope.row.status === 1 ? '审核通过' : scope.row.status === 2 ? '审核不通过' : '' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rejected" label="审核备注"></el-table-column>
        <el-table-column prop="paydStatus" label="支付状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.paydStatus ? 'success' : 'danger'" size="small" effect="dark">{{ scope.row.paydStatus ? '支付完成' : '待支付' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paydStatus" label="支付凭证" width="200px">
          <template slot-scope="scope">
            <el-image v-if="scope.row.payImageUrl"
              style="width: 100px; height: 100px"
              :src="scope.row.payImageUrl"
              :preview-src-list="[scope.row.payImageUrl]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="payNote" label="支付备注"></el-table-column>
        <el-table-column prop="date" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.status === 1 && !scope.row.paydStatus && scope.row.students" @click="handleToReg(scope.row, 4)">去缴费</el-button>
            <el-button type="text" size="small" v-if="scope.row.status === 2 && !scope.row.paydStatus" @click="handleToReg(scope.row, 1)">修改报名信息</el-button>
            <el-button type="text" size="small" @click="handleToReg(scope.row, 3)">编辑战队</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; padding: 0 0 20px;" v-if="list.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.pageNum"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      steps: [
        { cn: '选择方向', en: 'Select Field' },
        { cn: '项目立项', en: 'Project Initiation' },
        { cn: '信息审核', en: 'Info Review' },
        { cn: '组建战队', en: 'Build Team' },
        { cn: '报名支付', en: 'Register & Pay' }
      ],
      list: [],
      queryForm: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dict_schoolGroup: this.$curUtils.dict_schoolGroup(),
      statusArr: [
        // 0-已提交，1-审核通过/待缴费，2-审核未通过，3-已缴费 4-已退费
        { code: 0, label: '待缴费', type: 'warning' },
        { code: 1, label: '待缴费', type: 'warning' },
        { code: 2, label: '审核未通过', type: 'danger' },
        { code: 3, label: '已缴费', type: 'success' },
        { code: 4, label: '已退费', type: 'info' }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    downloadFn () {
      window.open('https://cdn.spbcn.org/ghac/file/学生展演指导手册.pdf')
      // this.fileLinkToStreamDownload('https://cdn.spbcn.org/ghac/file/学生展演指导手册.pdf', '学生展演指导手册')
    },
    getStepClass (index, item) {
      item.currentStep = item.status === 2 ? 1 : item.status === 0 ? 2 : !item.students ? 3 : !item.paydStatus ? 4 : 5
      if (index < item.currentStep) return 'step-done'
      if (index === item.currentStep) return 'step-active'
      return 'step-pending'
    },
    backClicked () {
      this.$router.back()
    },
    getList () {
      this.$http.get('pblTeam/page', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },
    levelFormat (data) {
      const arr = ['小学', '初中', '高中']
      return arr[Number(data.schoolLevel) - 1]
    },
    sexFormat (data) {
      return Number(data.sex) === 1 ? '女' : Number(data.sex) === 2 ? '男' : ''
    },
    handleToReg (item, step) {
      this.$router.push({
        path: '/club/register',
        query: {
          pblTeamId: item.id,
          step,
          isEdit: step === 1 || (step === 3 && item.students) ? 1 : 0,
          isPay: step === 4 ? 1 : 0
        }
      })
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getList()
    }
  }
}
</script>
<style scoped lang="less">
.download{
  text-decoration: underline;
  margin-top: 20px;
}
.backview {
  height: 100%;
  width: 100%;
}

.sec-title {
  width: 260px;
  height: 38px;
  background-image: url(https://cdn.spbcn.org/ghac/ghac_button_highlight.png);
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  font-family: hzgb;
  font-size: 18px;
  line-height: 38px;
  margin: 40px auto 30px;
  letter-spacing: 2px;
  cursor: pointer;
}
.upload{
  background-image: url(https://cdn.spbcn.org/ghac/flag-border.png);
  background-size: 560px 60px;
  background-position: center;
  background-repeat: no-repeat;
  width: 600px;
  height: 80px;
  line-height: 80px;
  margin: 20px auto;
  background-color: #b81b26;
  border-radius: 14px;
  color: #fff;
  font-size: 32px;
  font-family: regular;
  text-align: center;
  cursor: pointer;
}

.expand-wrap{
  padding: 0 20px 10px;
  // background-color: #fafafa;
}
.expand-section{
  .expand-title{
    font-size: 14px;
    font-weight: bold;
    color: #b81b26;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
.empty-tip{
  color: #999;
  font-size: 13px;
  text-align: center;
  padding: 10px 0;
}

.team-card{
  background-color: #CC3546;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 0 20px;
  margin-bottom: 20px;
  position: relative;
  .ope{
    display: none;
    position: absolute;
    top: 10px;
    bottom: 10px;
    right: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 5%;
    text-align: center;
    z-index: 1;
    .ope-btn{
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      font-family: systh;
      border-bottom: 1px dashed #fff;
      &:hover{
        border-bottom: 1px solid #fff;
      }
    }
  }
  &:hover .ope{
    display: flex;
  }
  &:hover .inner{
    width: 94%;
  }
  .inner{
    position: relative;
    z-index: 100;
    box-sizing: border-box;
    width: 100%;
    // margin: 0 auto;
    padding: 10px 20px;
    background-color: #fff;
    border-radius: 16px;
    min-height: 100px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: width 0.6s ease;
    .t1{
      color: #b81b26;
      font-size: 16px;
      font-family: systh;
    }
    .t2{
      color: #000;
      font-size: 14px;
      font-family: systh;
      .s{
        font-family: systm;
        margin-right: 8px;
        color: #999;
      }
    }
    .con1{
      display: flex;
      justify-content: space-between;
      .lf{
        width: 30%;
      }
      .lf-line{
        display: flex;
        align-items: center;
        margin-top: 10px;
        .t2{
          width: 50%;
        }
      }
      .rt{
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
      }
    }
  }
}
</style>
